// extracted by mini-css-extract-plugin
export var box = "_59-0";
export var check = "_59-1";
export var checkboxButton = "_59-6";
export var checkboxGroup = "_59-5";
export var disabled = "_59-7";
export var ghost = "_59-9";
export var input = "_59-2";
export var label = "_59-4";
export var normal = "_59-8";
export var uncheck = "_59-3";